const cookies = require('browser-cookies');
const { CookiesConsentManager } = require('@deliveroo/cookies-consent');
const { getCookiesConsentMode } = require('./helpers');

// if the cookie is not marked as "strictly necessary" in OneTrust,
// users will be able to disable it in their cookie preferences.
// please consider this when you're trying to use the cookie!
const maybeGetClientCookie = (key) => cookies.get(key);

// if you're using this method, your cookie must be categorised as
// "strictly necessary" in OneTrust. otherwise, please use the
// `maybeSetClientCookie` method and add your cookie to the
// `getCookieType()` method!
const setStrictlyNecessaryClientCookie = (key, val, options = undefined) => {
  cookies.set(key, val, options);
};

// If you're adding a new cookie through this method, you must add it to @deliveroo/cookies-consent.
// Otherwise your cookie will be marked as not allowed by default.
// Please visit https://github.com/deliveroo/js-common/packages/cookies-consent for more details.
const maybeSetClientCookie = (key, val, options = undefined) => {
  const oneTrustCookieRaw = cookies.get('OptanonConsent');
  const cookiesConsentManager = new CookiesConsentManager(
    oneTrustCookieRaw,
    getCookiesConsentMode(),
  );
  const cookieAllowed = cookiesConsentManager.isCookieAllowed(key);
  const isOneTrustEnabled = typeof window !== 'undefined' && window.isOneTrustCookieConsentEnabled;

  // don't check consent if OneTrust is not feature-flagged on
  if (!isOneTrustEnabled || cookieAllowed) {
    cookies.set(key, val, options);
  }
};

const deleteClientCookie = (key) => cookies.erase(key);

/* This method can be used for tracking purposes, to check whether a user has consented to a given cookie.
If you're trying to set a cookie, please use the `maybeSetClientCookie` which will handle everything for you! */
const isClientCookieAllowed = (key) => {
  const oneTrustCookieRaw = cookies.get('OptanonConsent');
  const cookiesConsentManager = new CookiesConsentManager(
    oneTrustCookieRaw,
    getCookiesConsentMode(),
  );
  const isOneTrustEnabled = typeof window !== 'undefined' && window.isOneTrustCookieConsentEnabled;
  // Only check consent if OneTrust is feature-flagged on
  if (isOneTrustEnabled) {
    return cookiesConsentManager.isCookieAllowed(key);
  }

  return true;
};

module.exports = {
  maybeGetClientCookie,
  setStrictlyNecessaryClientCookie,
  maybeSetClientCookie,
  deleteClientCookie,
  isClientCookieAllowed,
};
